// TODO: Move all Affirm logic from AffirmInteractor to the AffirmService

export default class AffirmService {
  public constructor() {}

  public refreshAffirmUi() {
    try {
      if (typeof window !== 'undefined' && window.affirm && typeof window.affirm.ui.refresh === 'function') {
        window.affirm.ui.refresh();
      }
    } catch (error) {
      console.error('Can`t provide Affirm script', error);
    }
  }
}
